// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AchNote } from './ach-note';
import { AchTransaction } from './ach-transaction';
import { Confirmation } from './confirmation';
import { Dealer } from './dealer';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Ach extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get invoiceNumbers() {
        return this.achTransactions.map((t) => t.invoice.invoiceNumber).join(', ');
    }
    get invoiceList() {
        const invoiceList = [];
        if (this.achTransactions && this.achTransactions.length > 0) {
            this.achTransactions.forEach((line) => {
                if (line.invoice && !_.includes(invoiceList, line.invoice.invoiceNumber)) {
                    invoiceList.push(line.invoice.invoiceNumber);
                }
            });
        }
        return invoiceList;
    }
    get invoicesTotal() {
        let total = 0;
        if (this.achTransactions && this.achTransactions.length > 0) {
            this.achTransactions.forEach((line) => {
                total += line.amount;
            });
        }
        return total;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  activated?: Date;
  amount!: number;
  approvalOverride!: boolean;
  approved?: Date;
  approvedBy?: string;
  bankDepositAcknowledged?: Date;
  bankDepositAcknowledgedBy?: string;
  bankName?: string;
  bankTransferConfirmation?: string;
  bankTransferInitiated?: Date;
  bankTransferInitiatedBy?: string;
  code!: string;
  completed?: Date;
  completedBy?: string;
  confirmationId?: number;
  created!: Date;
  createdBy?: string;
  dealerId!: number;
  declineReason?: string;
  declined?: Date;
  deleted?: Date;
  deletedBy?: string;
  emailMessage?: string;
  emailSubject?: string;
  emailTo?: string;
  emailed?: Date;
  manualFormSelected?: Date;
  message?: string;
  message2?: string;
  notes?: string;
  remoteIPAddress?: string;
  routingNumber?: string;
  type?: string;
  viewed?: Date;
  achNotes!: AchNote[];
  achTransactions!: AchTransaction[];
  confirmation!: Confirmation;
  dealer!: Dealer;
}

